import React from 'react';
import { useFinance } from '../../context/FinanceContext';

interface HeaderProps {
  toggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const { enabledCurrencies, selectedCurrency, changeCurrency } = useFinance();

  return (
    <header className="header">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <select
              value={selectedCurrency.code}
              onChange={(e) => changeCurrency(e.target.value)}
              className="form-control"
            >
              {enabledCurrencies.map((currency) => (
                <option key={currency.code} value={currency.code}>
                  {currency.code} ({currency.symbol})
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          {/* Empty space for potential future header content */}
        </div>
      </div>
    </header>
  );
};

export default Header;
